function decodeBase64(input) {
  const asciiString = Buffer.from(input, 'base64').toString();
  try {
    return JSON.parse(asciiString);
  } catch (_ignored) {
    return {};
  }
}

function decodeJWT(input) {
  const [_header, payload, _signature] = input.split('.');
  return decodeBase64(payload);
}

module.exports = { decodeBase64, decodeJWT };
